<template>
  <div class="checkTable">
    <div class="headLine">
      <img src="./leftAngle.png" alt="返回首页" @click="backIndex" />
      <div class="headTxt">查询线上爬取数据</div>
    </div>
    <el-tabs class="tabCard" v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="压力数据" name="press">
        <el-form ref="dataForm" class="searchForm" :model="dataForm">
          <el-form-item>
            <el-select
              v-model="dataForm.equipmentId"
              placeholder="请选择流量计"
              class="fullList"
              filterable
              @change="getStation"
            >
              <el-option
                v-for="item in stationOptions"
                :key="item.id"
                :label="item.flowMeterName"
                :value="item.id"
              />
            </el-select>
            <el-date-picker
              v-model="dataForm.startDate"
              type="date"
              class="fullList"
              placeholder="请选择开始时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
            <el-date-picker
              v-model="dataForm.endDate"
              type="date"
              class="fullList"
              placeholder="请选择结束时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
            <el-button type="primary" class="fullList" @click="getDataList(1)">查询</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="流量数据" name="flow">
        <el-form ref="dataForm" class="searchForm" :model="dataForm">
          <el-form-item>
            <el-select
              v-model="dataForm.equipmentId"
              placeholder="请选择流量计"
              class="fullList"
              filterable
              @change="getStation"
            >
              <el-option
                v-for="item in stationOptions"
                :key="item.id"
                :label="item.flowMeterName"
                :value="item.id"
              />
            </el-select>
            <el-date-picker
              v-model="dataForm.startDate"
              type="date"
              class="fullList"
              placeholder="请选择开始时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
            <el-date-picker
              v-model="dataForm.endDate"
              type="date"
              class="fullList"
              placeholder="请选择结束时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
            <el-button type="primary" class="fullList" @click="getDataList(1)">查询</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="通电状态" name="electrcity">
        <el-form ref="dataForm" class="searchForm" :model="dataForm">
          <el-form-item>
            <el-select
              v-model="dataForm.equipmentId"
              placeholder="请选择流量计"
              class="fullList"
              filterable
              @change="getStation"
            >
              <el-option
                v-for="item in stationOptions"
                :key="item.id"
                :label="item.flowMeterName"
                :value="item.id"
              />
            </el-select>
            <el-date-picker
              v-model="dataForm.startDate"
              type="date"
              class="fullList"
              placeholder="请选择开始时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
            <el-date-picker
              v-model="dataForm.endDate"
              type="date"
              class="fullList"
              placeholder="请选择结束时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
            <el-button type="primary" class="fullList" @click="getDataList(1)">查询</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <el-table
      :data="dataList"
      border
      lazy
      height="calc(80vh - 180px - 40px - 40px)"
      style="width: 100%"
      ref="scrollTable"
    >
      <el-table-column
        prop="date"
        header-align="center"
        align="center"
        width="100"
        label="爬取日期"
      />
<!--      <el-table-column-->
<!--        prop="nowtime"-->
<!--        header-align="center"-->
<!--        align="center"-->
<!--        width="80"-->
<!--        label="时间"-->
<!--      />-->
      <el-table-column
        prop="value"
        header-align="center"
        align="center"
        v-if="activeNum === 0"
        label="压力值"
      />
      <el-table-column
        prop="value"
        header-align="center"
        v-if="activeNum === 1"
        align="center"
        :label="isLiquidMeter ? '液位值' : '流量值'"
      >
        <template slot-scope="scope">
          {{ formatValue(scope.row.value) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="state"
        header-align="center"
        align="center"
        v-if="activeNum === 0 || activeNum === 1"
        label="状态"
      />
      <el-table-column
        prop="status"
        header-align="center"
        align="center"
        v-if="activeNum === 2"
        label="通电状态"
      >
        <template slot-scope="scope">
          <span style="color: #5daf34;font-weight: 600;" v-if="scope.row.status === 1">市电</span>
          <span style="color: #f00;font-weight: 600;" v-else-if="scope.row.status === 2 || scope.row.status === 0">市电停电</span>
          <span v-else>null</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :pager-count="5"
      :total="totalPage"
      style="margin: 15px 0;text-align: center"
      layout="prev, pager, next"
    />
  </div>
</template>

<script>
import moment from "moment"
export default {
  data () {
    return {
      activeName: "press",
      activeNum: 0,
      popstateLock: 0, //是否监听物理返回键
      dataForm: {
        equipmentId: null,
        area: null,
        startDate: moment(new Date()).startOf("month").format("YYYY-MM-DD"),
        endDate: moment(new Date()).format("YYYY-MM-DD")
      },
      pageIndex: 1,
      pageSize: 20,
      totalPage: 0,
      stationOptions: [],
      dataList: [], // 数据列表
      dataListLoading: false, // 数据加载
      loading: true
    }
  },
  created() {
    this.getAreaOption();
  },
  computed: {
    isLiquidMeter() {
      const liquidMeterIds = [35, 36, 37, 38];
      return this.activeNum === 1 && liquidMeterIds.includes(this.dataForm.equipmentId);
    }
  },
  watch:{
    popstateLock(val){
      //在父组件调用方法改变lock的值的时候控制路由的监听来避免preview的close路由调用
      if (val){
        this.addPopstate();
      }else{
        this.removePopstate();
      }
    }
  },
  mounted () {
    // this.getDataList()
    this.addPopstate(); //在导航栏挂载的时候，对物理返回键进行监听
    // this.scrollLoad();
  },
  destroyed(){
    this.removePopstate();
  },
  methods: {
    formatValue(value) {
      if (value === null || value === undefined || value === '') {
        return '-';
      }
      if (this.isLiquidMeter) {
        return Number(value).toFixed(2);
      }
      return value;
    },
    addPopstate(){
      //判断是否H5路由
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新，并绑定getBack()来控制
        window.addEventListener('popstate', this.getBack, false);//false阻止默认事件
      }
    },
    removePopstate(){
      //解除监听
      window.removeEventListener('popstate', this.getBack, false);//false阻止默认事件
    },
    //指挥路由
    getBack() {
      //判断物理返回键是否监听
      if (!this.popstateLock) {
        window.history.pushState(null, null, '#')
      }
    },
    // 获取选择数据
    handleClick(val) {
      this.activeName = val.name;
      this.activeNum = parseInt(val.index);
      this.getDataList(1);
    },
    // 获取选中的地址信息
    getStation(val) {
      this.stationOptions.forEach(item => {
        if (item.id === val) {
          this.dataForm.area = item.flowMeterName
        }
      })
    },
    // 流量计信息获取
    getAreaOption() {
      this.$http.httpGet('/app/tbEquipment/combo', {}).then(res => {
        if (res.code === 0 && res.msg === 'success') {
          this.stationOptions = res.list.filter(item => item.type === 1);
          // this.stationOptions = res.list
        } else {
          this.stationOptions = [];
          this.$message.error('获取数据失败: ' + res.msg)
        }
      })
    },
    // 后面获取数据列表
    async getDataList(type) {
      this.dataList = [];
      if (this.dataForm.startDate === null || this.dataForm.startDate === '') {
        this.dataForm.startDate = moment(new Date()).startOf("month").format("YYYY-MM-DD")
      }
      if (this.dataForm.endDate === null || this.dataForm.endDate === '') {
        this.dataForm.endDate = moment(new Date()).format("YYYY-MM-DD")
      }
      if (type === 1) {
        this.pageIndex = 1;
      }
      if (this.activeNum === 0) {
        if (this.dataForm.equipmentId === 10 || this.dataForm.equipmentId === 11 || this.dataForm.equipmentId === 28 || this.dataForm.equipmentId === 29) {
          this.$message.error("南江工业园没有压力数据！！！")
        }
      }
      if (this.activeNum === 2) {
        if (this.dataForm.equipmentId === 10 || this.dataForm.equipmentId === 11 || this.dataForm.equipmentId === 28 || this.dataForm.equipmentId === 29) {
          this.$message.error("南江工业园没有通电状态数据！！！")
        }
      }
      if (this.dataForm.equipmentId === null || this.dataForm.equipmentId === '') {
        this.$message.error("请选择需要查询的流量计信息");
      } else {
        if (moment(this.dataForm.endDate).isBefore(this.dataForm.startDate) == false) {
          // 根据获取的数据请求符合条件的工单
          let getUrl;
          if (this.activeNum === 0) {
            getUrl = '/app/stateData/pressureList';
          } else if (this.activeNum === 1) {
            getUrl = '/app/stateData/flowList';
          } else if (this.activeNum === 2) {
            getUrl = '/app/stateData/electricityList';
          } else {
            return ;
          }
          await this.$http.httpGet(getUrl, {
            startDateTime: this.dataForm.startDate + " 00:00:00",
            endDateTime: this.dataForm.endDate + " 23:59:59",
            equipmentId: this.dataForm.equipmentId,
            page: this.pageIndex,
            limit: this.pageSize
          }).then(res => {
            this.loading = false
            if (res.code === 0 && res) {
              if (res.page.list.length > 0) {
                res.page.list.forEach(i => {
                  i.date = i.time.substr(0, 16);
                  // i.nowtime = i.time.substr(11, 5)
                })
                this.dataList = res.page.list;
                this.totalPage = res.page.totalCount;
              } else {
                this.dataList = [];
                this.totalPage = 0;
                this.$message.error("没有数据")
              }
            } else {
              this.$message.error('获取数据失败: ' + res.msg);
              this.totalPage = 0;
              this.dataList = [];
            }
          }).catch(() => {
          })
        } else {
          this.$message.error("结束时间必须大于开始时间");
        }
      }
    },
    scrollLoad() {
      // 获取表格对象
      let dom = document.querySelector(".el-table__body-wrapper");
      dom.addEventListener("scroll", (v) => {
        const scrollDistance = dom.scrollHeight - dom.scrollTop - dom.clientHeight;
        // 判断是否到底，可以加载下一页
        if (scrollDistance <= 10) {
          // 判断是否全部加载完成
          if (this.totalPage <= this.pageIndex) {
            this.$message.warning("已经见底了 ～");
          } else {
            // 加载下一页方法
            this.loadMore();
          }
        }
      });
    },
    // 加载更多
    async loadMore() {
      this.loading = false;
      if (this.totalPage > this.pageIndex) {
        this.pageIndex = this.pageIndex + 1;
        // 根据获取的数据请求符合条件的工单
        let getUrl;
        if (this.activeNum === 0) {
          getUrl = '/app/stateData/pressureList';
        } else if (this.activeNum === 1) {
          getUrl = '/app/stateData/flowList';
        } else if (this.activeNum === 2) {
          getUrl = '/app/stateData/electricityList';
        } else {
          return ;
        }
        // 根据获取的数据请求符合条件的工单
        await this.$http.httpGet(getUrl, {
          startDateTime: this.dataForm.startDate + " 00:00:00",
          endDateTime: this.dataForm.endDate + " 23:59:59",
          equipmentId: this.dataForm.equipmentId,
          page: this.pageIndex,
          limit: this.pageSize
        }).then(res => {
          if (res && res.code === 0) {
            if (res.page.list.length > 0) {
              res.page.list.forEach(i => {
                i.date = i.time.substr(0, 16);
                // i.nowtime = i.time.substr(11, 5)
              })
              this.dataList = this.dataList.concat(res.page.list);
              this.totalCount = res.page.totalCount;
            } else {
              this.totalCount = res.page.totalCount;
            }
          } else {
            this.dataList = [];
            this.totalCount = 0;
            this.$message.error('获取数据失败: ' + res.msg)
          }
        }).catch(() => {
          this.loading = false;
        })
      }
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 返回首页
    backIndex() {
      this.$router.push({ name: 'Index' });
    }
  },

}
</script>

<style lang="scss">
.checkTable {
  position: relative;
  padding: 60px 10px 0;
  .headLine {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 998;
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    font-weight: 600;
    background-color: #409eff;
    color: #fff;
    text-align: center;
    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }
    .headTxt {
      font-size: 16px;
      line-height: 50px;
    }
  }

  .tabCard {
    position: relative;
    .el-tabs__nav {
      width: 100%;
      .el-tabs__item {
        width: calc(100% / 3);
        border-bottom: #5E5E5E;
        text-align: center;
      }
      .is-active {
        background-color: #409eff;
        color: #fff;
      }
    }
  }

  .searchForm {
    position: relative;
    .el-form-item {
      margin: 0 0 10px;
      position: relative;
      overflow: hidden;
      .el-form-item__content {
        .fullList {
          width: 100% !important;
          margin: 0 0 10px;
        }
        .el-select {
          width: 75%;
          float: left;
        }
        .el-button {
          width: 22%;
          float: right;
        }
      }
    }
  }

  //
  .recodList {
    position: relative;
    overflow: hidden;
    height: calc(100vh - 60px - 300px);
    .recordHead, .tableList {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      border: 1px #efefef solid;

      line-height: 30px;
      .headTime {
        width: 120px;
        font-size: 14px;
        text-align: center;
        padding: 8px;
        word-break: break-all;
      }
      .headValue {
        flex: 1;
        font-size: 14px;
        text-align: center;
        padding: 8px;
        border-left: 1px #efefef solid;
      }
      .greenTxt {
        color: green !important;
        font-weight: 600;
      }
      .redTxt {
        color: #f00 !important;
        font-weight: 600;
      }
    }
    .tableScrollPart {
      position: relative;
      overflow-x: hidden;
      overflow-y: auto;
      height: calc(100% - 48px);
    }
    .tableList {
      border-bottom: none;
      &:first-child {
        border-top: none;
      }
      &:last-child {
        border-bottom: 1px #efefef solid;
      }
    }
  }
}
</style>
